import React from 'react'
import { withTranslationCustom } from 'lib/i18next'

import AppContext from 'components/AppContext'
import RequireUserSwitchMessage from './RequireUserSwitchMessage'

const OfferRequireLogoutMessage = ({ t }) => {
    return (
        <AppContext context="offerRequireLogoutMessage">
            <RequireUserSwitchMessage
                title={t('errors:internal.1009.title')}
                description={t('errors:internal.1009.message')}
                logoutButtonText={t('errors:internal.1009.cta')}
            />
        </AppContext>
    )
}

export default withTranslationCustom('errors')(OfferRequireLogoutMessage)
